import { useMutation } from 'react-query';
import { StaticTokens, TerminalServicesAPI } from '../../constants/API';
import axios from 'axios';

type TicketDataType = {
  topicId: number;
  confirmationId?: string;
  extraData?: string;
};

export const useGetTicket = (onSuccess?: () => void, terminalIp?: string | null) => {
  const resolvedToken =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('token') || StaticTokens.terminalToken
      : StaticTokens.terminalToken;
  const {
    mutate: getTicket,
    isLoading: isLoadingGetTicket,
    isError
  } = useMutation(
    ['getTicket'],
    (data: TicketDataType) =>
      axios.post(TerminalServicesAPI.getTicketInTerminal, data, {
        headers: {
          'X-API-TOKEN': resolvedToken
        }
      }),
    {
      onSuccess: (response) => {
        const itemId = response?.data?.itemId;
        if (itemId) {
          const printBody: { terminalIp?: string; localPrint: boolean } = {
            localPrint: true
          };
          if (terminalIp != null && terminalIp.trim() !== '') {
            printBody.terminalIp = terminalIp.trim();
          }
          axios
            .post(
              TerminalServicesAPI.printTicketInTerminal(itemId),
              printBody,
              {
                headers: {
                  'X-API-TOKEN': resolvedToken,
                  'Content-Type': 'application/json'
                }
              }
            )
            .then((printResponse) => {
              const payload = printResponse?.data?.printerPayload;
              if (!payload) {
                return;
              }
              return axios.post('http://127.0.0.1:8081/api/printer/print', payload);
            })
            .catch(() => {
              // print failures should not block ticket creation
            });
        }

        onSuccess?.();
      }
    }
  );

  return { getTicket, isLoadingGetTicket, isError };
};
